interface ErrorResponse {
  code: string;
  message: string;
  action: string;
}

export const AuthError = {
  NETWORK_ERROR: {
    code: 'NETWORK_ERROR',
    message: 'Unable to connect to the server. Please check your internet connection.',
    action: 'Please try again when you have a stable connection.',
  },
  INVALID_CREDENTIALS: {
    code: 'INVALID_CREDENTIALS',
    message: 'Invalid login credentials.',
    action: 'Please try logging in again.',
  },
  TOKEN_EXPIRED: {
    code: 'TOKEN_EXPIRED',
    message: 'Your session has expired.',
    action: 'Please log in again to continue.',
  },
  TOKEN_REFRESH_FAILED: {
    code: 'TOKEN_REFRESH_FAILED',
    message: 'Failed to refresh your session.',
    action: 'Please log in again to continue.',
  },
  GOOGLE_AUTH_FAILED: {
    code: 'GOOGLE_AUTH_FAILED',
    message: 'Google authentication failed.',
    action: 'Please try logging in again or use a different Google account.',
  },
  SERVER_ERROR: {
    code: 'SERVER_ERROR',
    message: 'An unexpected error occurred.',
    action: 'Please try again later or contact support if the problem persists.',
  },
} as const satisfies Record<string, ErrorResponse>;

export const getErrorMessage = (error: string): ErrorResponse => {
  if (error.includes('network')) {
    return AuthError.NETWORK_ERROR;
  }
  if (error.includes('expired')) {
    return AuthError.TOKEN_EXPIRED;
  }
  if (error.includes('Google')) {
    return AuthError.GOOGLE_AUTH_FAILED;
  }
  if (error.includes('credentials')) {
    return AuthError.INVALID_CREDENTIALS;
  }
  if (error.toLowerCase().includes('login')) {
    return { ...AuthError.SERVER_ERROR, message: 'Login failed' } as ErrorResponse;
  }
  if (error.toLowerCase().includes('token')) {
    return { ...AuthError.SERVER_ERROR, message: 'Invalid token' } as ErrorResponse;
  }
  return AuthError.SERVER_ERROR;
};
